<app-header></app-header>
<div class="container-md px-md-0" *ngIf="!showWelcomePage">
  <div class="row">
    <div class="col-md-12">
      <div class="terms" >
        <h2>Terms and Conditions</h2>
        <div class="mat-typography mt-3" >
          <div class="tc-table" [innerHTML]="termsAndCondition.content"></div>
        </div>
        <div class="check-section">
          <mat-checkbox name="termchk" *ngIf ="!isFromFooter" class="example-margin"  [ngClass]="{ 'is-invalid': !termCheck && isTermCheckSubmit }" (change)="onTermsCheckBoxChange($event)">I agree to the Terms & Conditions</mat-checkbox>
          <div class="invalid-feedback">
          <mat-error *ngIf="!termCheck && isTermCheckSubmit">Please acknowledge that you have read and agree to the Terms and Conditions in order to proceed.</mat-error>
          </div>
        </div>
        <div class="row mb-5">
          <div class="col-12 col-sm-6">
            <button class="secondary-button" *ngIf ="!isFromFooter" (click)="onClickToCancel()">CANCEL</button>
          </div>
          <div class="col-12 col-sm-6 text-right">
            <button class="primary-button" *ngIf ="!isFromFooter" appDebounceClick (debounceClick)="onClickToRedirectToHomePage()" [debounceTime]="500">NEXT</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
<div class="container px-0" *ngIf="showWelcomePage">
    <div class="row">
      <div class="col-md-12">
        <div class="terms" >
            <h2>Welcome to KPMG Creditors Central Portal</h2>
          <h3>Terms and Conditions</h3>
          <p class="mb-0">By using this system, you are deemed to have read and agreed to the following Terms and Conditions:</p>
          <div class="mat-typography p-4 mt-4">
           <div class="tc-table" [innerHTML]="termsAndCondition.content"></div>
          </div>
          <div class="check-section">
            <mat-checkbox name="termchk" class="example-margin"  [ngClass]="{ 'is-invalid': !termCheck && isTermCheckSubmit }" (change)="onTermsCheckBoxChange($event)">I agree to the Terms and Conditions</mat-checkbox>
            <div class="invalid-feedback">
            <mat-error *ngIf="!termCheck && isTermCheckSubmit">Please acknowledge that you have read and agree to the Terms and Conditions in order to proceed.</mat-error>
            </div>
          </div>
          <div class="row mb-5">
            <div class="col-12 col-sm-6">
                <button class="secondary-button" (click)="onClickToCancel()">CANCEL</button>
            </div>
            <div class="col-12 col-sm-6">
              <button class="primary-button float-right" appDebounceClick (debounceClick)="onClickToRedirectToHomePage()" [debounceTime]="500">PROCEED</button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
      
      
      
